import {
  SidebarMenu,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar"
import { HEADER_HEIGHT } from "@/constants/UiConstants"
import { useNavigate } from "react-router"
import { LogoIcon } from "./common/Logo/LogoIcon"

export function SidebarLogo() {
  const { state } = useSidebar()
  const navigate = useNavigate()

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <div
          onClick={() => navigate("/")}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              navigate("/")
            }
          }}
          role="button"
          tabIndex={0}
          style={{
            height: HEADER_HEIGHT,
            cursor: "pointer",
          }}
          className={
            state === "expanded"
              ? "data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
              : ""
          }
        >
          <div
            className={
              state === "expanded"
                ? "flex h-full w-full items-center justify-start rounded-lg"
                : "flex aspect-square h-full w-full items-center justify-center rounded-lg"
            }
          >
            {state === "expanded" ? (
              <div className="px-4">
                <LogoIcon className="h-6 text-yellow1" />
              </div>
            ) : (
              <img
                src="/favicon-dark.png"
                alt=""
                aria-hidden
                className="size-8"
              />
            )}
          </div>
        </div>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
